// extracted by mini-css-extract-plugin
module.exports = {"footer":"MiniContactPanel_footer__3qVkH","divider":"MiniContactPanel_divider__gFp0v","stickyNav":"MiniContactPanel_stickyNav__Vhm7V","text":"MiniContactPanel_text__qGoJe"};